const AUTH_ERROR_TRANSLATIONS: Record<string, string> = {
  "Invalid login credentials": "E-Mail oder Passwort ist falsch.",
  "User already registered": "Für diese E-Mail-Adresse existiert bereits ein Konto.",
  "Email not confirmed":
    "Bitte bestätige zuerst deine E-Mail-Adresse über den Link, den wir dir geschickt haben.",
  "Password should be at least 6 characters":
    "Das Passwort muss mindestens 6 Zeichen lang sein.",
  "Unable to validate email address: invalid format":
    "Bitte gib eine gültige E-Mail-Adresse ein.",
  "email rate limit exceeded":
    "Gerade wurden zu viele E-Mails verschickt. Bitte warte ein paar Minuten und versuche es erneut.",
  "New password should be different from the old password.":
    "Das neue Passwort muss sich vom alten unterscheiden.",
  "Auth session missing!":
    "Dieser Link ist abgelaufen oder ungültig. Fordere einen neuen Link zum Zurücksetzen an.",
};

export function translateAuthError(message: string): string {
  if (message.startsWith("For security purposes")) {
    return "Bitte warte einen Moment, bevor du es erneut versuchst.";
  }
  return (
    AUTH_ERROR_TRANSLATIONS[message] ??
    "Das hat gerade nicht geklappt. Bitte später erneut versuchen."
  );
}
